// extracted by mini-css-extract-plugin
export default {"paragraph":"FlexCreditCheckoutMessage-module__paragraph__Te17P"};